// Old address of the reading preview; plans now live at /plans.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/reading")({
  beforeLoad: () => {
    throw redirect({ to: "/plans", replace: true });
  },
});
